import _objectSpread from "/home/jenkins/agent/workspace/chongyueyuedsn29/cyy-manage-web-new/node_modules/@babel/runtime/helpers/esm/objectSpread2.js";
import _toConsumableArray from "/home/jenkins/agent/workspace/chongyueyuedsn29/cyy-manage-web-new/node_modules/@babel/runtime/helpers/esm/toConsumableArray.js";
import _regenerator from "/home/jenkins/agent/workspace/chongyueyuedsn29/cyy-manage-web-new/node_modules/@babel/runtime/helpers/esm/regenerator.js";
import _asyncToGenerator from "/home/jenkins/agent/workspace/chongyueyuedsn29/cyy-manage-web-new/node_modules/@babel/runtime/helpers/esm/asyncToGenerator.js";
import "core-js/modules/es.error.cause.js";
import "core-js/modules/es.array.concat.js";
import "core-js/modules/es.array.push.js";
import "core-js/modules/es.object.to-string.js";
/**
 * 注册、登录、注销
 * */
import util from "@/libs/util";
import router from '@/router';
import { AccountLogin, AccountLogout, AccountRegister, getLoginUser as _getLoginUser, updateUserInfo as _updateUserInfo } from '@api/system/account';
import Toast from '@/utils/toast';
import { Modal } from 'view-ui-plus';
import Setting from '@/setting';
import { frameInRoutes } from '@/router/routes';
import store from '@/store/index';
import { includeArray } from '@/libs/system';
import Token from '@/plugins/auth/token';
export default {
  namespaced: true,
  state: {
    hasGetUser: false
  },
  mutations: {
    setHasGetUser: function setHasGetUser(state, hasGetUser) {
      return state.hasGetUser = hasGetUser;
    }
  },
  actions: {
    /**
     * @description 登录
     * @param {Object} context
     * @param loginName {String} 用户账号
     * @param password {String} 密码
     * @param param route {Object} 登录成功后定向的路由对象 任何 vue-router 支持的格式
     */
    login: function login(_ref) {
      var dispatch = _ref.dispatch;
      var _ref2 = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {},
        _ref2$loginName = _ref2.loginName,
        loginName = _ref2$loginName === void 0 ? '' : _ref2$loginName,
        _ref2$password = _ref2.password,
        password = _ref2$password === void 0 ? '' : _ref2$password;
      return new Promise(function (resolve, reject) {
        // 开始请求登录接口
        AccountLogin({
          loginName: loginName,
          password: password
        }).then(/*#__PURE__*/function () {
          var _ref3 = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee(result) {
            return _regenerator().w(function (_context) {
              while (1) switch (_context.n) {
                case 0:
                  // 设置 cookie 一定要存 uuid 和 token 两个 cookie
                  // 整个系统依赖这两个数据进行校验和存储
                  // uuid 是用户身份唯一标识 用户注册的时候确定 并且不可改变 不可重复
                  // token 代表用户当前登录状态 建议在网络请求中携带 token
                  // 如有必要 token 需要定时更新，默认保存一天，可在 setting.js 中修改
                  // 如果你的 token 不是通过 cookie 携带，而是普通字段，也可视情况存储在 localStorage
                  util.cookies.set('uuid', result.data.user.code);
                  util.cookies.set('token', result.data.tokenInfo.token);
                  // 设置 vuex 用户信息
                  _context.n = 1;
                  return dispatch('admin/user/set', result.data.user, {
                    root: true
                  });
                case 1:
                  _context.n = 2;
                  return dispatch('load', {
                    loadOpenedTabs: Setting.page.loadOpenedTabs
                  });
                case 2:
                  // 获取动态菜单
                  // if (Setting.dynamicMenu) await dispatch('admin/menu/getMenuList', false, { root: true });
                  // 结束
                  resolve();
                case 3:
                  return _context.a(2);
              }
            }, _callee);
          }));
          return function (_x) {
            return _ref3.apply(this, arguments);
          };
        }()).catch(function (err) {
          reject(err);
        });
      });
    },
    /**
     * @description 退出登录
     * */
    logout: function logout(_ref4) {
      var state = _ref4.state,
        commit = _ref4.commit,
        dispatch = _ref4.dispatch;
      var _ref5 = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {},
        to = _ref5.to,
        _ref5$confirm = _ref5.confirm,
        confirm = _ref5$confirm === void 0 ? false : _ref5$confirm,
        _ref5$query = _ref5.query,
        query = _ref5$query === void 0 ? {
          redirect: to && to.fullPath || router.currentRoute.value.fullPath || '/'
        } : _ref5$query,
        vm = _ref5.vm;
      var handleLogout = function handleLogout() {
        // 删除cookie
        util.cookies.remove('token');
        util.cookies.remove('uuid');
        commit('setHasGetUser', false);
        // 清空 vuex 用户信息
        dispatch('admin/user/set', {}, {
          root: true
        }).finally(function () {
          router.push({
            name: 'login',
            query: query
          });
        });
      };
      var logoutFun = function logoutFun() {
        AccountLogout().then(function () {
          handleLogout();
        }).catch(function () {}).finally(function () {
          handleLogout();
        });
      };
      if (Token.get()) {
        if (confirm) {
          Modal.confirm({
            title: vm.$t('basicLayout.logout.confirmTitle'),
            content: vm.$t('basicLayout.logout.confirmContent'),
            onOk: function onOk() {
              logoutFun();
            }
          });
        } else {
          // handleLogout();
          Toast.Modal.warning({
            title: '登录超时',
            content: '您的登录已超时，请重新登录！',
            ok: function ok() {
              logoutFun();
            }
          });
        }
      } else {
        handleLogout();
      }
    },
    /**
     * @description 注册
     * @param context {Object}
     * @param mobile {String} 手机号
     * @param email {String} 邮箱
     * @param userName {String} 用户名
     * @param nickName {String} 姓名
     * @param validCode {String} 验证码
     * @param password {String} 密码
     * @param remark {String} 备注
     */
    register: function register(_ref6) {
      var dispatch = _ref6.dispatch;
      var _ref7 = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {},
        _ref7$mobile = _ref7.mobile,
        mobile = _ref7$mobile === void 0 ? '' : _ref7$mobile,
        _ref7$email = _ref7.email,
        email = _ref7$email === void 0 ? '' : _ref7$email,
        _ref7$userName = _ref7.userName,
        userName = _ref7$userName === void 0 ? '' : _ref7$userName,
        _ref7$nickName = _ref7.nickName,
        nickName = _ref7$nickName === void 0 ? '' : _ref7$nickName,
        _ref7$password = _ref7.password,
        password = _ref7$password === void 0 ? '' : _ref7$password,
        _ref7$validCode = _ref7.validCode,
        validCode = _ref7$validCode === void 0 ? '' : _ref7$validCode,
        _ref7$remark = _ref7.remark,
        remark = _ref7$remark === void 0 ? '' : _ref7$remark;
      return new Promise(function (resolve, reject) {
        // 开始请求登录接口
        AccountRegister({
          mobile: mobile,
          email: email,
          userName: userName,
          nickName: nickName,
          password: password,
          validCode: validCode,
          remark: remark
        }).then(function () {
          // 注册成功后，完成与登录一致的操作
          // 注册也可视情况不返还 uuid、token 等数据，在注册完成后，由前端自动执行一次登录逻辑
          // util.cookies.set('uuid', res.uuid);
          // util.cookies.set('token', res.token);
          // 设置 vuex 用户信息
          // await dispatch('admin/user/set', res.info, { root: true });
          // 用户登录后从持久化数据加载一系列的设置
          // await dispatch('load');
          // 结束
          resolve(true);
        }).catch(function (err) {
          reject(err);
        });
      });
    },
    /**
     * @description 用户登录后从持久化数据加载一系列的设置
     * @param {Object} state vuex state
     * @param {Object} dispatch vuex dispatch
     * @param {Object} loadOpenedTabs 是否加载页签信息
     */
    load: function load(_ref8) {
      var state = _ref8.state,
        dispatch = _ref8.dispatch;
      var _ref9 = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {},
        _ref9$loadOpenedTabs = _ref9.loadOpenedTabs,
        loadOpenedTabs = _ref9$loadOpenedTabs === void 0 ? true : _ref9$loadOpenedTabs;
      return new Promise(/*#__PURE__*/function () {
        var _ref0 = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee2(resolve) {
          return _regenerator().w(function (_context2) {
            while (1) switch (_context2.n) {
              case 0:
                _context2.n = 1;
                return dispatch('admin/user/load', null, {
                  root: true
                });
              case 1:
                _context2.n = 2;
                return dispatch('admin/page/openedLoad', {
                  loadOpenedTabs: loadOpenedTabs
                }, {
                  root: true
                });
              case 2:
                // end
                resolve();
              case 3:
                return _context2.a(2);
            }
          }, _callee2);
        }));
        return function (_x2) {
          return _ref0.apply(this, arguments);
        };
      }());
    },
    /**
     * 获取登录用户
     * @param commit
     * @returns {Promise<unknown>}
     */
    getLoginUser: function getLoginUser(_ref1, _ref10) {
      var commit = _ref1.commit,
        dispatch = _ref1.dispatch;
      var next = _ref10.next,
        to = _ref10.to;
      return new Promise(function (resolve, reject) {
        try {
          _getLoginUser().then(/*#__PURE__*/function () {
            var _ref11 = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee4(result) {
              return _regenerator().w(function (_context4) {
                while (1) switch (_context4.n) {
                  case 0:
                    if (result.data) {
                      _context4.n = 1;
                      break;
                    }
                    reject(new Error('为获取到用户信息，需要重新登录'));
                    _context4.n = 5;
                    break;
                  case 1:
                    commit('setHasGetUser', true);
                    // 设置用户信息
                    _context4.n = 2;
                    return dispatch('admin/user/set', result.data.user, {
                      root: true
                    });
                  case 2:
                    _context4.n = 3;
                    return store.dispatch('admin/menu/getRouters', to).then(/*#__PURE__*/function () {
                      var _ref12 = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee3(accessRouters) {
                        var initOpened;
                        return _regenerator().w(function (_context3) {
                          while (1) switch (_context3.n) {
                            case 0:
                              // 初始化菜单池，因为是动态路由，所以需要把本地路由和动态路由加入菜单池中
                              initOpened = [].concat(_toConsumableArray(frameInRoutes), _toConsumableArray(accessRouters));
                              _context3.n = 1;
                              return store.commit('admin/page/init', initOpened);
                            case 1:
                              _context3.n = 2;
                              return store.dispatch('admin/page/openedLoad', {
                                loadOpenedTabs: Setting.page.loadOpenedTabs
                              }, {
                                root: true
                              });
                            case 2:
                              // const {auth} =  to.meta
                              // const access = result.data.access;
                              // const isPermission = includeArray(auth, access);
                              // if (auth === true || isPermission) {
                              //     next && next({...to, replace: true});// hack方法 确保addRoutes已完成
                              // } else {
                              //     next({
                              //         name: '403'
                              //     });
                              // }
                              next && next(_objectSpread(_objectSpread({}, to), {}, {
                                replace: true
                              })); // hack方法 确保addRoutes已完成
                            case 3:
                              return _context3.a(2);
                          }
                        }, _callee3);
                      }));
                      return function (_x4) {
                        return _ref12.apply(this, arguments);
                      };
                    }()).catch(function (err) {
                      reject(err);
                    });
                  case 3:
                    _context4.n = 4;
                    return store.dispatch('admin/menu/getMenuList', to);
                  case 4:
                    // await store.dispatch('load',true);
                    resolve(result.data);
                  case 5:
                    return _context4.a(2);
                }
              }, _callee4);
            }));
            return function (_x3) {
              return _ref11.apply(this, arguments);
            };
          }()).catch(function (err) {
            reject(err);
          });
        } catch (error) {
          reject(error);
        }
      });
    },
    updateUserInfo: function updateUserInfo(_ref13, data) {
      var commit = _ref13.commit,
        dispatch = _ref13.dispatch;
      return new Promise(function (resolve, reject) {
        try {
          _updateUserInfo(data).then(/*#__PURE__*/function () {
            var _ref14 = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee5(result) {
              return _regenerator().w(function (_context5) {
                while (1) switch (_context5.n) {
                  case 0:
                    commit('setHasGetUser', true);
                    _context5.n = 1;
                    return dispatch('admin/user/set', result.data.user, {
                      root: true
                    });
                  case 1:
                    resolve(result.data);
                  case 2:
                    return _context5.a(2);
                }
              }, _callee5);
            }));
            return function (_x5) {
              return _ref14.apply(this, arguments);
            };
          }()).catch(function (err) {
            reject(err);
          });
        } catch (error) {
          reject(error);
        }
      });
    }
  }
};